import { render, staticRenderFns } from "./KontrakListTwo.vue?vue&type=template&id=b74ddf40&scoped=true&"
import script from "./KontrakListTwo.vue?vue&type=script&lang=js&"
export * from "./KontrakListTwo.vue?vue&type=script&lang=js&"
import style0 from "./KontrakListTwo.vue?vue&type=style&index=0&id=b74ddf40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74ddf40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Project/Gitpanda/Agroforestcape/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VBtn,VDataTable,VDivider,VFlex,VIcon,VList,VTextField,VToolbar})
